import { createFileRoute, Outlet } from "@tanstack/react-router";
import InspectionDetailLayout from "@/app/inspections/[id]/layout";

export const Route = createFileRoute("/inspections/$id")({
  component: () => (
    <InspectionDetailLayout>
      <Outlet />
    </InspectionDetailLayout>
  ),
});
